import React from 'react';

import styles from './LearnMore.module.scss';

interface LearnMoreProps {
  href: string;
}

export function LearnMore(props: LearnMoreProps) {
  const { href } = props;

  return (
    <a className={styles.container} href={href} target="_blank" rel="noopener noreferrer">
      Learn more
    </a>
  );
}
